import { render, staticRenderFns } from "./AsesoramientoJuridico.vue?vue&type=template&id=901ead18&scoped=true&"
var script = {}
import style0 from "./AsesoramientoJuridico.vue?vue&type=style&index=0&id=901ead18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901ead18",
  null
  
)

export default component.exports